import { createApp } from 'vue'
import App from './App.vue'
import AppLoadingSpinner from '@/components/AppLoadingSpinner'
import IdLabel from '@/components/IdLabel'
import router from './router'
import store from './store'

import CoreuiVue from '@coreui/vue'
import CIcon from '@coreui/icons-vue'
import { iconsSet as icons } from '@/assets/icons'
import DocsExample from '@/components/DocsExample'
import Notifications from '@kyvg/vue3-notification'

const app = createApp(App)
app.use(store)
app.use(router)
app.use(CoreuiVue)
app.use(Notifications)
app.provide('icons', icons)
app.component('CIcon', CIcon)
app.component('DocsExample', DocsExample)
app.component('AppLoadingSpinner', AppLoadingSpinner)
app.component('IdLabel', IdLabel)

app.mount('#app')
